const ContactForm = () => {
    return (
        <form
            className="
       

        shadow-sm
     
      
        space-y-5
      "
        >
            {/* Header */}
            <div className="mb-6">
                <h2
                    className="
            text-2xl
            md:text-3xl
            font-bold
            text-gray-900
          "
                >
                    Send Message
                </h2>

                <p
                    className="
            mt-2
            text-gray-600
            leading-relaxed
          "
                >
                   We're here to help you find the right healthcare equipment
                    for your needs.
                </p>
            </div>

            <input
                type="text"
                placeholder="Full Name"
                className="
          w-full
          border
          border-gray-200
          rounded-lg
          px-4
          py-3
          focus:outline-none
          focus:ring-2
          focus:ring-green-500
        "
            />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input
                    type="email"
                    placeholder="Email Address"
                    className="
      w-full
      border
      border-gray-200
      rounded-lg
      px-4
      py-3
      focus:outline-none
      focus:ring-2
      focus:ring-green-500
    "
                />

                <input
                    type="text"
                    placeholder="Phone Number"
                    className="
      w-full
      border
      border-gray-200
      rounded-lg
      px-4
      py-3
      focus:outline-none
      focus:ring-2
      focus:ring-green-500
    "
                />
            </div>
            <textarea
                rows="5"
                placeholder="Your Message"
                className="
          w-full
          border
          border-gray-200
          rounded-lg
          px-4
          py-3
          focus:outline-none
          focus:ring-2
          focus:ring-green-500
          resize-none
        "
            />

            <button
                className="
          w-full
          bg-green-600
          text-white
          py-3
          rounded-lg
          font-semibold
          hover:bg-green-700
          transition
        "
            >
                Send Message
            </button>
        </form>
    );
};

export default ContactForm;